import { CheckIcon, Icon, type StackProps, XStack } from 'smoothie';

import {
    BankingPolicyDisclosures,
    HYS_ACCOUNT_OPEN_POLICY_DISCLOSURES,
} from './Disclosures';

interface BankingTermsProps extends StackProps {
    termsAccepted: boolean;
    onPress: () => void;
}

const LegacyBankingTerms = ({
    termsAccepted,
    onPress,
    ...props
}: BankingTermsProps) => {
    return (
        <XStack gap={8} {...props}>
            <XStack
                marginTop={2}
                marginRight={4}
                alignItems="center"
                justifyContent="center"
                height={28}
                width={28}
                borderWidth={1}
                borderRadius={8}
                borderColor={termsAccepted ? '$green900' : '$black'}
                backgroundColor={termsAccepted ? '$green900' : '$white'}
                onPress={onPress}
            >
                <Icon icon={CheckIcon} color="$white" size={16} />
            </XStack>
            <BankingPolicyDisclosures
                acknowledgementText="I acknowledge I have read and agreed to Fruitful’s "
                policies={HYS_ACCOUNT_OPEN_POLICY_DISCLOSURES}
            />
        </XStack>
    );
};

export default LegacyBankingTerms;
